import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsButtonArea',
  setup(__props) {


return { __sfc: true,BCXItemsWithPoints }
}

})